
import { motion } from 'framer-motion';
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const certificates = [
    {
      icon: 'ri-shield-check-line',
      title: 'ISO 22000',
      description: 'Food Safety Management System',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-health-book-line',
      title: 'HACCP',
      description: 'Hazard Analysis Critical Control',
      color: 'from-green-500 to-green-600'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Organic Certified',
      description: 'EU & USDA Organic Standards',
      color: 'from-emerald-500 to-emerald-600'
    },
    {
      icon: 'ri-global-line',
      title: 'Global GAP',
      description: 'Good Agricultural Practices',
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-award-line',
      title: 'BRC Certified',
      description: 'British Retail Consortium',
      color: 'from-orange-500 to-orange-600'
    },
    {
      icon: 'ri-recycle-line',
      title: 'Sustainable',
      description: 'Environmental Standards',
      color: 'from-teal-500 to-teal-600'
    }
  ];

  const timeline = [
    {
      year: '1995',
      title: 'Company Foundation',
      description: 'Started as a small family business in Istanbul, focusing on local fruit and vegetable processing.',
      icon: 'ri-seedling-line'
    },
    {
      year: '2001',
      title: 'First Export',
      description: 'Expanded to international markets, beginning exports to European countries.',
      icon: 'ri-ship-line'
    },
    {
      year: '2008',
      title: 'Facility Expansion',
      description: 'Built state-of-the-art freezing and processing facility with 10,000 MT capacity.',
      icon: 'ri-building-line'
    },
    {
      year: '2015',
      title: 'Global Reach',
      description: 'Established partnerships in 45+ countries across Europe, Asia, and Americas.',
      icon: 'ri-global-line'
    },
    {
      year: '2020',
      title: 'Sustainability Initiative',
      description: 'Launched eco-friendly packaging and carbon-neutral shipping programs.',
      icon: 'ri-leaf-line'
    },
    {
      year: '2024',
      title: 'Innovation Hub',
      description: 'Today we lead the industry with cutting-edge freeze-drying technology and quality.',
      icon: 'ri-rocket-line'
    }
  ];

  const team = [
    {
      name: 'Mehmet Özkan',
      role: 'CEO & Founder',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Turkish%20businessman%20in%20suit%2C%20confident%20smile%2C%20corporate%20headshot%2C%20clean%20background%2C%20executive%20portrait%2C%20high%20quality%20corporate%20photography&width=400&height=400&seq=team1&orientation=squarish',
      description: '25+ years experience in food export industry'
    },
    {
      name: 'Sarah Thompson',
      role: 'Export Director',
      image: 'https://readdy.ai/api/search-image?query=Professional%20businesswoman%2C%20international%20trade%20expert%2C%20confident%20corporate%20headshot%2C%20clean%20background%2C%20executive%20portrait%2C%20export%20industry%20professional&width=400&height=400&seq=team2&orientation=squarish',
      description: 'International trade specialist with global network'
    },
    {
      name: 'Dr. Ahmed Hassan',
      role: 'Quality Manager',
      image: 'https://readdy.ai/api/search-image?query=Food%20scientist%20in%20lab%20coat%2C%20quality%20control%20expert%2C%20professional%20headshot%2C%20laboratory%20background%2C%20food%20safety%20specialist%2C%20corporate%20portrait&width=400&height=400&seq=team3&orientation=squarish',
      description: 'PhD in Food Science, quality assurance expert'
    },
    {
      name: 'Elena Rodriguez',
      role: 'Logistics Director',
      image: 'https://readdy.ai/api/search-image?query=Professional%20logistics%20manager%2C%20supply%20chain%20expert%2C%20businesswoman%20portrait%2C%20corporate%20headshot%2C%20clean%20background%2C%20international%20shipping%20specialist&width=400&height=400&seq=team4&orientation=squarish',
      description: 'Supply chain optimization and global logistics'
    },
    {
      name: 'Li Wei Chen',
      role: 'Production Manager',
      image: 'https://readdy.ai/api/search-image?query=Production%20manager%20in%20food%20processing%20facility%2C%20industrial%20engineering%20background%2C%20professional%20portrait%2C%20manufacturing%20expert%2C%20operations%20specialist&width=400&height=400&seq=team5&orientation=squarish',
      description: 'Food processing and production efficiency expert'
    },
    {
      name: 'Maria Silva',
      role: 'Sustainability Officer',
      image: 'https://readdy.ai/api/search-image?query=Environmental%20sustainability%20expert%2C%20eco-friendly%20business%20professional%2C%20green%20technology%20specialist%2C%20corporate%20headshot%2C%20clean%20background%2C%20sustainability%20officer&width=400&height=400&seq=team6&orientation=squarish',
      description: 'Environmental impact and sustainable practices'
    }
  ];

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Quality First',
      description: 'We maintain the highest quality standards in every process, from farm to fork.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Excellence',
      description: 'Serving customers worldwide with consistent quality and reliable delivery.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Sustainability',
      description: 'Committed to environmental responsibility and sustainable business practices.'
    },
    {
      icon: 'ri-team-line',
      title: 'Partnership',
      description: 'Building long-term relationships with farmers, customers, and communities.'
    }
  ];

  return (
    <div className="min-h-screen relative">
      {/* Full Page Background - Same as Home Hero */}
      <div 
        className="fixed inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Hand-drawn%20fruits%20and%20vegetables%20doodles%2C%20sketch%20style%20illustrations%2C%20organic%20produce%20drawings%2C%20colorful%20food%20sketches%2C%20healthy%20eating%20doodles%2C%20minimalist%20line%20art%2C%20white%20background%20with%20scattered%20fruit%20vegetable%20illustrations&width=1920&height=1080&seq=abouthero&orientation=landscape)`
        }}
      >
        <div className="absolute inset-0 bg-white/90"></div>
      </div>

      {/* Content Wrapper */}
      <div className="relative z-10">
        <Header />
        
        {/* Hero Section */}
        <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
          {/* Floating Elements */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <motion.div
              animate={{ 
                y: [0, -20, 0],
                rotate: [0, 5, 0]
              }}
              transition={{ 
                duration: 6,
                repeat: Infinity,
                ease: "easeInOut"
              }}
              className="absolute top-20 left-10 text-6xl"
            >
              🍓
            </motion.div>
            <motion.div
              animate={{ 
                y: [0, 20, 0],
                rotate: [0, -5, 0]
              }}
              transition={{ 
                duration: 8,
                repeat: Infinity,
                ease: "easeInOut",
                delay: 1
              }}
              className="absolute top-32 right-20 text-5xl"
            >
              🥦
            </motion.div>
            <motion.div
              animate={{ 
                y: [0, -15, 0],
                rotate: [0, 3, 0]
              }}
              transition={{ 
                duration: 7,
                repeat: Infinity,
                ease: "easeInOut",
                delay: 2
              }}
              className="absolute bottom-40 left-20 text-4xl"
            >
              🍋
            </motion.div>
            <motion.div
              animate={{ 
                y: [0, 25, 0],
                rotate: [0, -3, 0]
              }}
              transition={{ 
                duration: 9,
                repeat: Infinity,
                ease: "easeInOut",
                delay: 0.5
              }}
              className="absolute bottom-20 right-10 text-5xl"
            >
              🥕
            </motion.div>
          </div>

          <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
            <motion.h1
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, ease: "easeOut" }}
              className="text-6xl lg:text-8xl font-bold mb-6"
            >
              <span className="bg-gradient-to-r from-primary-600 via-green-600 to-emerald-600 bg-clip-text text-transparent">
                About Us
              </span>
            </motion.h1>
            
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
              className="text-xl lg:text-2xl text-gray-700 leading-relaxed max-w-3xl mx-auto"
            >
              Pioneering excellence in frozen fruits and vegetables export since 1995. 
              From farm to global markets, we deliver premium quality with sustainability at heart.
            </motion.p>
          </div>
        </section>

        {/* Company Story Section */}
        <section className="py-20 bg-white/30 backdrop-blur-[2px]">
          <div className="container mx-auto px-4">
            <div className="grid lg:grid-cols-2 gap-16 items-center">
              {/* Left Column - Image */}
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
                className="relative"
              >
                <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Modern%20food%20processing%20facility%20with%20frozen%20fruits%20and%20vegetables%2C%20export%20logistics%20warehouse%2C%20industrial%20freezing%20equipment%2C%20quality%20control%20laboratory%2C%20global%20shipping%20containers%2C%20professional%20food%20industry%20photography&width=800&height=600&seq=aboutfacility&orientation=landscape"
                    alt="Our Facility"
                    className="w-full h-96 object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                </div>
                
                {/* Floating Stats */}
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.4, duration: 0.6 }}
                  className="absolute -bottom-6 -right-6 bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-gray-100/50"
                >
                  <div className="text-center">
                    <div className="text-3xl font-bold text-primary-600 mb-1">45+</div>
                    <div className="text-gray-600 text-sm">Countries Served</div>
                  </div>
                </motion.div>
                
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.6, duration: 0.6 }}
                  className="absolute -top-6 -left-6 bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-gray-100/50"
                >
                  <div className="text-center">
                    <div className="text-3xl font-bold text-green-600 mb-1">29</div>
                    <div className="text-gray-600 text-sm">Years Experience</div>
                  </div>
                </motion.div>
              </motion.div>

              {/* Right Column - Content */}
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
                className="space-y-8"
              >
                {/* Who We Are */}
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center gap-3 drop-shadow-sm">
                    <i className="ri-building-line text-primary-600"></i>
                    Who We Are
                  </h2>
                  <p className="text-gray-800 leading-relaxed drop-shadow-sm">
                    FrozenExport is a leading Turkish exporter of premium frozen fruits, vegetables, and freeze-dried products. 
                    Founded in 1995, we have grown from a small family business into a global supplier, serving over 45 countries 
                    across Europe, Asia, and the Americas with unwavering commitment to quality and sustainability.
                  </p>
                </div>

                {/* Our Mission */}
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3 drop-shadow-sm">
                    <i className="ri-target-line text-green-600"></i>
                    Our Mission
                  </h3>
                  <p className="text-gray-800 leading-relaxed drop-shadow-sm">
                    To deliver the highest quality frozen and freeze-dried fruits and vegetables to global markets, 
                    while supporting sustainable agriculture and creating value for farmers, customers, and communities worldwide.
                  </p>
                </div>

                {/* Our Vision */}
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3 drop-shadow-sm">
                    <i className="ri-eye-line text-blue-600"></i>
                    Our Vision
                  </h3>
                  <p className="text-gray-800 leading-relaxed drop-shadow-sm">
                    To be the most trusted and innovative global leader in frozen food exports, setting industry standards 
                    for quality, sustainability, and customer satisfaction while contributing to global food security.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Our Values */}
        <section className="py-20 bg-white/30 backdrop-blur-[2px]">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl font-bold text-gray-900 mb-4 drop-shadow-sm">Our Values</h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto drop-shadow-sm">
                The principles that guide every decision we make and every relationship we build
              </p>
            </motion.div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {values.map((value, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.6 }}
                  whileHover={{ y: -5 }}
                  className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-100/50 text-center group hover:shadow-xl transition-all duration-300"
                >
                  <div className={`w-16 h-16 bg-gradient-to-r ${
                    index === 0 ? 'from-primary-500 to-primary-600' :
                    index === 1 ? 'from-blue-500 to-blue-600' :
                    index === 2 ? 'from-green-500 to-green-600' :
                    'from-purple-500 to-purple-600'
                  } rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${value.icon} text-white text-2xl`}></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4 drop-shadow-sm">{value.title}</h3>
                  <p className="text-gray-700 leading-relaxed drop-shadow-sm">{value.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Certificates & Quality */}
        <section className="py-20 bg-white/30 backdrop-blur-[2px]">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl font-bold text-gray-900 mb-4 drop-shadow-sm">Certificates & Quality Standards</h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto drop-shadow-sm">
                Certified excellence and internationally recognized quality standards ensure the safety and quality of our products
              </p>
            </motion.div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {certificates.map((cert, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.6 }}
                  whileHover={{ y: -8, scale: 1.02 }}
                  className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 shadow-lg text-center group hover:shadow-2xl transition-all duration-300 border border-gray-100/50"
                >
                  <div className={`w-20 h-20 bg-gradient-to-r ${cert.color} rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${cert.icon} text-white text-3xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 drop-shadow-sm">{cert.title}</h3>
                  <p className="text-gray-700 drop-shadow-sm">{cert.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Timeline Section */}
        <section className="py-20 bg-white/30 backdrop-blur-[2px]">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl font-bold text-gray-900 mb-4 drop-shadow-sm">Our Journey</h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto drop-shadow-sm">
                From humble beginnings to global leadership - our milestones tell the story of growth, innovation, and dedication
              </p>
            </motion.div>

            <div className="relative">
              {/* Timeline Line */}
              <div className="absolute left-1/2 transform -translate-x-0.5 h-full w-1 bg-gradient-to-b from-primary-400 to-green-600 hidden lg:block"></div>
              
              <div className="space-y-12">
                {timeline.map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.2, duration: 0.8 }}
                    className={`flex items-center gap-8 ${
                      index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                    } flex-col lg:text-left text-center`}
                  >
                    {/* Content */}
                    <div className="flex-1 lg:w-1/2">
                      <div className={`bg-white/95 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-100/50 ${
                        index % 2 === 0 ? 'lg:mr-8' : 'lg:ml-8'
                      }`}>
                        <div className="flex items-center gap-4 mb-4 justify-center lg:justify-start">
                          <div className="w-12 h-12 bg-gradient-to-r from-primary-500 to-green-600 rounded-full flex items-center justify-center">
                            <i className={`${item.icon} text-white text-xl`}></i>
                          </div>
                          <span className="text-2xl font-bold text-primary-600 drop-shadow-sm">{item.year}</span>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3 drop-shadow-sm">{item.title}</h3>
                        <p className="text-gray-700 leading-relaxed drop-shadow-sm">{item.description}</p>
                      </div>
                    </div>

                    {/* Timeline Dot */}
                    <div className="w-6 h-6 bg-gradient-to-r from-primary-500 to-green-600 rounded-full border-4 border-white shadow-lg hidden lg:block relative z-10"></div>
                    
                    {/* Spacer */}
                    <div className="flex-1 lg:w-1/2 hidden lg:block"></div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="py-20 bg-white/30 backdrop-blur-[2px]">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl font-bold text-gray-900 mb-4 drop-shadow-sm">Meet Our Team</h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto drop-shadow-sm">
                The passionate professionals behind our success, bringing expertise, innovation, and dedication to everything we do
              </p>
            </motion.div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {team.map((member, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.6 }}
                  whileHover={{ y: -10, scale: 1.02 }}
                  className="bg-white/95 backdrop-blur-sm rounded-2xl overflow-hidden shadow-lg group hover:shadow-2xl transition-all duration-300 border border-gray-100/50"
                >
                  <div className="relative overflow-hidden">
                    <img 
                      src={member.image}
                      alt={member.name}
                      className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-2 drop-shadow-sm">{member.name}</h3>
                    <p className="text-primary-600 font-semibold mb-3 drop-shadow-sm">{member.role}</p>
                    <p className="text-gray-700 text-sm drop-shadow-sm">{member.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
}
